var $ = require('jquery');

web = window.web = window.web || {};

web.AnchorSlider = module.exports = function(options) {
    var t = this;
    t.instanceState = 'constructed';

    t.defaults = {
        anyDefaultOption: true
    };

    t.options = $.extend({}, t.defaults, options);
};

web.AnchorSlider.prototype = {
    init:  function(){
        var t = this;
        t.instanceState = 'inicialized';

        t._bindEvents();
    },

    _bindEvents: function(){
        var t = this;

        t.instanceState = 'binded';

        $("body").on("click", ".js_anchorSlide-goTo", function(e){
            var href = $(this).attr("href")

            if (href.indexOf("#") != -1) {
                var $href = $("#"+href.split("#")[1]);
                if ($href.length > 0) {
                    t._goTo($href, 0);

                    e.stopPropagation();
                    e.preventDefault();
                }
            }
        });
    },

    _unBindEvents: function(){
        var t = this;

        t.instanceState = 'unbinded';
    },

    _goTo: function($href, offset){
        var t = this;

        $("html, body").animate({ scrollTop: $href.offset().top+offset }, 500);
    },

    scrollTo: function($elm, offset) {
        var t = this;

        t._goTo($elm, offset||0)
    }

}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/AnchorSlider.js